import { Grid } from "./s25.virtual.grid";
import { GridUtil } from "./s25.virtual.grid.util";
import { S25Number } from "../../util/core/s25.number";

export namespace GridDrag {
    export function getFullGridOffset(
        data: Grid.DragSession<any, any> & {
            resolution: Grid.Coord;
            columnHeadersMeta: GridUtil.HeadersMeta<any>;
            rowHeadersMeta: GridUtil.HeadersMeta<any>;
            gridHeight: number;
            gridWidth: number;
        },
    ) {
        const offsetX = getFullGridOffset1D({
            offsetPercent: data.offset.x,
            gridPx: data.gridWidth,
            resolution: data.resolution.x,
            headersMeta: data.columnHeadersMeta,
            initClippedPosition: data.init.clippedPosition.left,
            size: data.grabbedProjection!.position().width,
            initPosition: data.init.position.left,
            snapOffset: data.grabbedProjection!.source.snapOffset?.().x ?? 0,
        });
        const offsetY = getFullGridOffset1D({
            offsetPercent: data.offset.y,
            gridPx: data.gridHeight,
            resolution: data.resolution.y,
            headersMeta: data.rowHeadersMeta,
            initClippedPosition: data.init.clippedPosition.top,
            size: data.grabbedProjection!.position().height,
            initPosition: data.init.position.top,
            snapOffset: data.grabbedProjection!.source.snapOffset?.().y ?? 0,
        });

        return { x: offsetX, y: offsetY };
    }

    function getFullGridOffset1D(data: {
        offsetPercent: number;
        gridPx: number;
        resolution: number;
        snapOffset: number;
        headersMeta: GridUtil.HeadersMeta<any>;
        initClippedPosition: number;
        initPosition: number;
        size: number;
    }) {
        const { resolution, headersMeta } = data;
        if (!data.gridPx || !headersMeta.visibleCount()) return 0;

        // Snap
        const visiblePosition = data.initClippedPosition + data.offsetPercent;
        const visibleSnapped = GridUtil.snap(visiblePosition, resolution, data.snapOffset, headersMeta.visibleCount());

        // Clamp to the full grid so that no part of the item goes off-grid
        let fullPosition = GridUtil.getPositionBeforeHidingHeaders(visibleSnapped, headersMeta);
        fullPosition = S25Number.clamp(fullPosition, 0, 100 - data.size);

        // Clamp to visible grid so that the item doesn't go fully off-screen
        const visibleResolution = (resolution / headersMeta.visibleCount()) * 100;
        const minEnd = GridUtil.getPositionBeforeHidingHeaders(visibleResolution, headersMeta);
        const maxStart = GridUtil.getPositionBeforeHidingHeaders(100 - visibleResolution, headersMeta);
        fullPosition = S25Number.clamp(fullPosition, minEnd - data.size, maxStart);

        return fullPosition - data.initPosition;
    }
}
